export default function activeEntityKey(editorState) {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const startKey = selection.getStartKey();
  const currentBlock = contentState.getBlockForKey(startKey);
  return currentBlock.getEntityAt(selection.getStartOffset());
}
